module.exports = __webpack_public_path__ + "img/img7.937bff9a.png";